// @flow
import Sentry from "@nested/isomorphic-sentry";
import { getConfig } from "@nested/config";

const { SENTRY_DSN, SENTRY_REPORTING_ENABLED, RELEASE_VERSION } = getConfig();

const configureSentry = () => {
  Sentry.onLoad(() => {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.NODE_ENV,
      release: RELEASE_VERSION,
      beforeSend: (event) => {
        if (SENTRY_REPORTING_ENABLED !== "true") {
          // This drops the event before sending to Sentry outside of production
          console.log(event.message);
          return null;
        }
        return event;
      },
    });
  });

  /* eslint-disable-next-line dot-notation */
  window["_fs_ready"] = () => {
    if (window.FS && typeof window.FS.getCurrentSessionURL === "function") {
      Sentry.configureScope((scope) => {
        scope.setExtra(
          "fullStoryCurrentSessionURL",
          window.FS.getCurrentSessionURL(),
        );
      });
    }
  };
};

export default configureSentry;
